<template>
  <div class="bankCardField">
    <div class="label"><span class="required">*</span>{{ label }}</div>
    <div class="value">
      <div class="field-bank-card">
        <input
          v-model="bankCardNumber"
          type="number"
          inputmode="numeric"
          :placeholder="placeholder"
          @input="handleInput"
          @blur="handleBlur"
        />
        <span v-show="bankErrTip" ref="error" class="error"
          >请输入正确的银行卡号</span
        >
      </div>
      <div class="bankCardFieldImg">
        <img :src="ocrIcon" alt="" @click="ocrBankCard" />
        <div class="input">
          <input
            type="file"
            ref="backInput"
            hidden
            @change="onBackChange"
            accept="image/png, image/jpeg, image/jpg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { verificationBankCardOCR } from "@/api/index.js";
import ocrIcon from "@/assets/style/ocr-icon.png";
import { compressImage, validateBankCard } from "@/utils/utils.js";

export default {
  name: "BankCardField",
  components: {},
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "输入您的卡号",
    },
  },
  data() {
    return {
      bankCardNumber: "",
      ocrIcon,
      backImgRaw: "",
      validateBankCard,
      bankErrTip: false,
    };
  },
  async mounted() {},
  methods: {
    init() {
      this.bankErrTip = false;
    },
    handleBlur() {
      if (!this.validateBankCard(this.bankCardNumber)) {
        this.bankErrTip = true;
        return;
      } else {
        this.bankErrTip = false;
      }
    },
    handleInput(val) {
      val = String(val.target.value || "").replace(/\D/g, "");
      this.$emit("input", val);
    },
    ocrBankCard() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "5" });
        this.$JSBridge.listen("pushBankORC", async (res) => {
          console.log(res, "pushBankORC事件");
          this.bankErrTip = false;
          this.$store.commit("setBankCardInfo", res.data);
          this.$emit("input", res.data.bankCardNumber);
          this.bankCardNumber = res.data.bankCardNumber;
          this.$store.commit(
            "setBankName",
            res.data.bankName?.split("(")[0] || "",
          );
          this.$refs.backInput.value = "";
        });
      } else {
        this.$refs.backInput.click();
      }
    },
    readFileAsDataUrl(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target?.result || "");
        reader.onerror = () => resolve("");
        reader.readAsDataURL(file);
      });
    },
    //处理图片上传
    async onBackChange(e) {
      const inputEl = e?.target;
      const file = e.target.files[0];
      if (!file) return;
      const compressed = await compressImage(file);
      const base64 = await this.readFileAsDataUrl(compressed);
      const pureBase64 = base64.replace(
        /^data:image\/(png|jpeg|jpg|webp);base64,/,
        "",
      );
      const res = await verificationBankCardOCR({ image: pureBase64 });
      if (res.code !== 2000) {
        this.$toast(res.msg || res.message || "请求失败");
        e.target.value = "";
        this.$refs.backInput.value = "";
        return;
      } else {
        if (inputEl) inputEl.value = "";
        this.$store.commit("setBankCardInfo", res.data);
        this.$emit("input", res.data.bankCardNumber);
        this.bankCardNumber = res.data.bankCardNumber;
        this.bankErrTip = false;
        this.$store.commit(
          "setBankName",
          res.data.bankName?.split("(")[0] || "",
        );
        e.target.value = "";
        this.$refs.backInput.value = "";
      }
    },
  },
  watch: {
    value(val) {
      this.bankCardNumber = val;
    },
  },
};
</script>

<style scoped lang="scss">
.bankCardField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required {
    color: #ff4444;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 38px;
  justify-content: space-between;
  border-radius: 17px;
  background: #f8f8f8;
  padding: 0px 12px;
  .field-bank-card {
    position: relative;
    flex: 1;
    input {
      border: none;
      outline: none;
      background: transparent;
      font-size: 14px;
      color: #333333;
      &::placeholder {
        color: rgba(170, 170, 170, 0.67);
      }
    }
    .error {
      position: absolute;
      top: 30px;
      left: 0;
      font-size: 12px;
      color: #ff4444;
      padding-left: 12px;
    }
  }
  .bankCardFieldImg {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    img {
      height: 18px;
      margin-left: 8px;
    }
  }
}
</style>
